import { render, staticRenderFns } from "./RepresentativesForm.vue?vue&type=template&id=50ad43b0&scoped=true&"
import script from "./RepresentativesForm.vue?vue&type=script&lang=js&"
export * from "./RepresentativesForm.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativesForm.vue?vue&type=style&index=0&id=50ad43b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad43b0",
  null
  
)

export default component.exports